import React from 'react';
import { CTA } from '@volkswagen-onehub/components-core';
import { getTranslations } from '../translations';

export const PrivacyPolicyLink = () => {
  const { search_modal: copy } = getTranslations();

  return (
    <CTA
      target='_blank'
      tag="a"
      emphasis="tertiary"
      href={copy.privacy_policy.link}
      ariaLabel={copy.privacy_policy.label}
    >
      { copy.privacy_policy.label }
    </CTA>
  );
};
